import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/data";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("ipn_token"));

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("ipn_token", res.data.token);
    setToken(res.data.token);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ipn_token");
    setToken(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, isAuthed: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
